import { createStore } from 'vuex'
import auth from './modules/auth'
import message from './modules/message'

const store = createStore({
  modules: {
    auth,
    message,
  }
})

// Optional: expose to window
if (typeof window !== 'undefined') {
  window.$store = store
}

export default store
